//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React, { useState, useContext } from 'react';
import { makeStyles } from '@material-ui/core';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
// import { makeStyles } from '@material-ui/core/styles';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import Typography from '@material-ui/core/Typography';
import FlagIcon from '@material-ui/icons/Flag';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
import { AppContext, LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { CONFIRM_DIALOG_TITLE_DELETE_THREAD, CONFIRM_DIALOG_MESSAGE_DELETE_THREAD } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------
import { markThreadForFollowUp, deleteThread } from '../../common/services/myMessagesServices';

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
import AfitdConfirmDialog from '../../common/elemental/AfitdConfirmDialog';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
// import _get from 'lodash/get';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    return makeStyles(theme => ({
        root: {
            backgroundColor: '#FFFFFF',
        },
        // buttonLabel: {
        //     lineHeight: '20px',
        //     paddingTop: '6px',
        //     paddingBottom: '6px',
        //     // paddingRight: '17px',
        //     fontSize: '15px',
        //     fontWeight: 600,
        //     textTransform: 'none',
        // },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const {
        classes,
        props,
        userId,
        employerId,
        clearCurrentThread,
        anchorEl,
        setAnchorEl,
        setSnackbarMessage,
        setSnackbarErrorMessage,
        // isConfirmReportDialogOpen,
        setIsConfirmReportDialogOpen,
        // isConfirmBlockDialogOpen,
        // setIsConfirmBlockDialogOpen,
        isConfirmDeleteDialogOpen,
        setIsConfirmDeleteDialogOpen,
    } = params;
    const { threadId, reportedDt, markedForFollowUpDt, blockedDt } = props;

    const isMenuOpen = !!anchorEl;
    const isReported = !!reportedDt;
    const actionById = userId;

    const defns = {
        moreIconButton: {
            onClick: handleClickMoreIconButton.bind(null, setAnchorEl),
        },
        menu: {
            open: isMenuOpen,
            getContentAnchorEl: null,
            anchorEl,
            anchorOrigin: { vertical: 'top', horizontal: 'left' },
            transformOrigin: { vertical: 'top', horizontal: 'right' },
            onClose: handleCloseMenu.bind(null, setAnchorEl),
            closable: true,
        },
        reportMenuItem: {
            onClick: handleClickReportMenuItem.bind(null, setIsConfirmReportDialogOpen, setAnchorEl),
            disabled: !!blockedDt || isReported,
        },
        reportMenuItemLabel: {
            value: isReported ? 'Thread Reported' : 'Report Thread',
        },
        followUpMenuItem: {
            onClick: handleClickFollowUpMenuItem.bind(null, actionById, threadId, markedForFollowUpDt, setSnackbarMessage, setSnackbarErrorMessage, setAnchorEl),
            disabled: !!blockedDt,
        },
        followUpMenuItemLabel: {
            value: markedForFollowUpDt ? 'Remove Follow Up' : 'Mark for Follow Up',
        },
        // blockMenuItem: {
        //     onClick: handleClickBlockMenuItem.bind(null, setIsConfirmBlockDialogOpen, setAnchorEl),
        //     disabled: !!blockedDt,
        // },
        // blockMenuItemLabel: {
        //     value: blockedDt ? 'Thread Blocked' : 'Block Thread',
        // },
        deleteMenuItem: {
            onClick: handleClickDeleteMenuItem.bind(null, setIsConfirmDeleteDialogOpen, setAnchorEl),
        },
        // confirmReportThreadDialog: {
        //     title: CONFIRM_DIALOG_TITLE_REPORT_THREAD,
        //     onClose: handleCloseConfirmReportDialog.bind(null, setIsConfirmReportDialogOpen),
        //     onConfirm: handleClickConfirmReportDialogYes.bind(null, actionById, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmReportDialogOpen, setAnchorEl),
        //     open: isConfirmReportDialogOpen,
        //     message: CONFIRM_DIALOG_MESSAGE_REPORT_THREAD,
        // },
        // confirmBlockThreadDialog: {
        //     title: CONFIRM_DIALOG_TITLE_BLOCK_THREAD,
        //     onClose: handleCloseConfirmBlockDialog.bind(null, setIsConfirmBlockDialogOpen),
        //     onConfirm: handleClickConfirmBlockDialogYes.bind(null, isEmployer, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmReportDialogOpen, setAnchorEl),
        //     open: isConfirmBlockDialogOpen,
        //     message: CONFIRM_DIALOG_MESSAGE_BLOCK_THREAD,
        // },
        confirmDeleteThreadDialog: {
            title: CONFIRM_DIALOG_TITLE_DELETE_THREAD,
            onClose: handleCloseConfirmDeleteDialog.bind(null, setIsConfirmDeleteDialogOpen),
            onConfirm: handleClickConfirmDeleteDialogYes.bind(
                null,
                actionById,
                employerId,
                threadId,
                clearCurrentThread,
                setSnackbarMessage,
                setSnackbarErrorMessage,
                setIsConfirmDeleteDialogOpen,
                setAnchorEl,
            ),
            open: isConfirmDeleteDialogOpen,
            message: CONFIRM_DIALOG_MESSAGE_DELETE_THREAD,
        },
    };

    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------
const handleClickMoreIconButton = (setAnchorEl, evt) => {
    setAnchorEl(evt.currentTarget);
};

const handleCloseMenu = setAnchorEl => {
    setAnchorEl(null);
};

const handleClickReportMenuItem = (setIsConfirmReportDialogOpen, setAnchorEl) => {
    setIsConfirmReportDialogOpen(true);
    setAnchorEl(null);
};

const handleClickFollowUpMenuItem = (actionById, threadId, markedForFollowUpDt, setSnackbarMessage, setSnackbarErrorMessage, setAnchorEl) => {
    markThreadForFollowUp({ actionById, threadId, markedForFollowUpDt, setSnackbarMessage, setSnackbarErrorMessage });
    setAnchorEl(null);
};

// const handleClickBlockMenuItem = (setIsConfirmBlockDialogOpen, setAnchorEl) => {
//     setIsConfirmBlockDialogOpen(true);
//     setAnchorEl(null);
// };

// const handleCloseConfirmReportDialog = setIsConfirmReportDialogOpen => {
//     setIsConfirmReportDialogOpen(false);
// };

// const handleClickConfirmReportDialogYes = (actionById, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmReportDialogOpen, setAnchorEl) => {
//     reportThread({ actionById, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmReportDialogOpen, setAnchorEl });
// };

// const handleCloseConfirmBlockDialog = setIsConfirmBlockDialogOpen => {
//     setIsConfirmBlockDialogOpen(false);
// };

// const handleClickConfirmBlockDialogYes = (isEmployer, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmBlockDialogOpen, setAnchorEl) => {
//     blockThread({ isEmployer, threadId, setSnackbarMessage, setSnackbarErrorMessage, setIsConfirmBlockDialogOpen, setAnchorEl });
// };

const handleClickDeleteMenuItem = (setIsConfirmDeleteDialogOpen, setAnchorEl) => {
    setIsConfirmDeleteDialogOpen(true);
    setAnchorEl(null);
};

const handleCloseConfirmDeleteDialog = setIsConfirmDeleteDialogOpen => {
    setIsConfirmDeleteDialogOpen(false);
};

const handleClickConfirmDeleteDialogYes = (
    actionById,
    employerId,
    threadId,
    clearCurrentThread,
    setSnackbarMessage,
    setSnackbarErrorMessage,
    setIsConfirmDeleteDialogOpen,
    setAnchorEl,
) => {
    console.log({
        actionById,
        threadId,
        setSnackbarMessage,
        setSnackbarErrorMessage,
        setIsConfirmDeleteDialogOpen,
        setAnchorEl,
        clearCurrentThread,
    });
    deleteThread({
        internal: true,
        employerId,
        actionById,
        threadId,
        setSnackbarMessage,
        setSnackbarErrorMessage,
        setIsConfirmDeleteDialogOpen,
        setAnchorEl,
        clearCurrentThread,
    });
};

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const ThreadMenuButton = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    const classes = useStyles(/*{param1, param2}*/)();
    const appContext = useContext(AppContext);
    const { employerId } = appContext;
    const context = useContext(LayoutContext);
    const { userId, clearCurrentThread, setSnackbarMessage, setSnackbarErrorMessage } = context;

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [anchorEl, setAnchorEl] = useState(null);
    const [isConfirmReportDialogOpen, setIsConfirmReportDialogOpen] = useState(false);
    const [isConfirmBlockDialogOpen, setIsConfirmBlockDialogOpen] = useState(false);
    const [isConfirmDeleteDialogOpen, setIsConfirmDeleteDialogOpen] = useState(false);

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------
    // useEffect(() => {
    //     const newDefns = getDefns(props, { });
    //     setDefns(newDefns);
    // }, [props]);

    //---------------------------------------------------------------------
    // Defns
    //---------------------------------------------------------------------
    const defns = getDefns({
        classes,
        props,
        userId,
        employerId,
        clearCurrentThread,
        anchorEl,
        setAnchorEl,
        setSnackbarMessage,
        setSnackbarErrorMessage,
        isConfirmReportDialogOpen,
        setIsConfirmReportDialogOpen,
        isConfirmBlockDialogOpen,
        setIsConfirmBlockDialogOpen,
        isConfirmDeleteDialogOpen,
        setIsConfirmDeleteDialogOpen,
    });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------
    return (
        <div>
            <IconButton aria-label="menu" {...defns.moreIconButton}>
                <MoreVertIcon />
            </IconButton>
            <Menu {...defns.menu}>
                <MenuItem {...defns.followUpMenuItem}>
                    <ListItemIcon>
                        <FlagIcon />
                    </ListItemIcon>
                    <Typography variant="inherit">{defns.followUpMenuItemLabel.value}</Typography>
                </MenuItem>

                <MenuItem {...defns.deleteMenuItem}>
                    <ListItemIcon>
                        <DeleteForeverIcon />
                    </ListItemIcon>
                    <Typography variant="inherit">Delete Thread</Typography>
                </MenuItem>
            </Menu>
            {isConfirmDeleteDialogOpen && <AfitdConfirmDialog {...defns.confirmDeleteThreadDialog} />}
        </div>
    );
};

export default ThreadMenuButton;
